import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { OnboardingProgressPopupComponent } from './onboarding-progress-popup.component';

@NgModule({
  declarations: [OnboardingProgressPopupComponent],
  imports: [CommonModule, MatIconModule],
  exports: [OnboardingProgressPopupComponent],
})
export class OnboardingProgressPopupModule {}
